import { css } from '@emotion/css';

export const headerAnimation = css`
  &.header-enter {
    opacity: 1;
    transform: translateY(-100%);
  }
  &.header-enter-active {
    transform: translateY(0%);
    transition: transform 200ms;
  }
  &.header-exit {
    opacity: 1;
    transform: translateY(0%);
  }
  &.header-exit-active {
    transform: translateY(-100%);
    transition: transform 200ms;
  }
`;

export const headerContentTransition = css`
  transition: all 200ms;
`;
